var map = {
	"./whyscanteak_1.jpg": 1404,
	"./whyscanteak_2.jpg": 3387,
	"./whyscanteak_3.jpg": 5342,
	"./whyscanteak_4.jpg": 7813,
	"./whyscanteak_5.jpg": 9944,
	"./whyscanteak_6.jpg": 3751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8324;